import type { FC, ReactElement } from "react"

import { LazyMotion, domAnimation } from "framer-motion"
import { Outlet } from "react-router-dom"

import { EParticipantHeaderVariant, ParticipantFooter, ParticipantHeader, ViewAsBanner } from "@/3514/components"
import { useDefaultStylesReset, useHtmlScrollbarGutter, useIsFakeParticipant } from "@/3514/hooks"
import { buildCssClassName } from "@/3514/utils"

const LAYOUT_CLASS_NAME: string = "p-onb-layout"

const classes = {
    main: (): string =>
        buildCssClassName(
            "relative flex flex-col items-center [min-height:100dvh] pb-[20px] md:pb-[50px]",
            LAYOUT_CLASS_NAME
        ),
    container: ({ isFakeParticipant }: { isFakeParticipant: boolean }): string =>
        buildCssClassName(
            "w-full flex flex-1 flex-col items-center overflow-hidden",
            isFakeParticipant && "top-[70px] md:top-0 relative"
        ),
    outletWrapper: (): string => "flex-1 flex flex-col w-full"
} as const

const Layout: FC = (): ReactElement => {
    useHtmlScrollbarGutter({ isEnabled: true })

    useDefaultStylesReset(LAYOUT_CLASS_NAME)

    const isFakeParticipant: boolean = useIsFakeParticipant()

    return (
        <div className={classes.main()}>
            <ParticipantHeader variant={EParticipantHeaderVariant.Onboarding} />

            <main className={classes.container({ isFakeParticipant })}>
                {isFakeParticipant && <ViewAsBanner />}

                <div className={classes.outletWrapper()}>
                    <LazyMotion features={domAnimation} key="pol-lm">
                        <Outlet />
                    </LazyMotion>
                </div>
            </main>

            <ParticipantFooter mode="onboarding" />
        </div>
    )
}

Layout.displayName = "ParticipantOnboardingLayout"

export { Layout as ParticipantOnboardingLayout }
